import { render, staticRenderFns } from "./loudong.vue?vue&type=template&id=0d97a397&scoped=true&"
import script from "./loudong.vue?vue&type=script&lang=js&"
export * from "./loudong.vue?vue&type=script&lang=js&"
import style0 from "./loudong.vue?vue&type=style&index=0&id=0d97a397&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97a397",
  null
  
)

export default component.exports